import { useEffect, useState } from 'react';
import type { LeaderboardResponse } from '@chromarble/shared-types';
import { ErrorNote, Screen, formatScore, pct } from '../components/ui';
import { api } from '../services/api';
import { useSession } from '../services/session';

export default function LeaderboardPage() {
  const user = useSession((s) => s.user)!;
  const [period, setPeriod] = useState<'weekly' | 'all'>('weekly');
  const [data, setData] = useState<LeaderboardResponse | null>(null);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    setData(null);
    api.leaderboard(period).then(setData, setError);
  }, [period]);

  return (
    <Screen title="Crew 랭킹" back="/">
      <div className="tabs" role="tablist">
        <button role="tab" aria-selected={period === 'weekly'} className={period === 'weekly' ? 'on' : ''} onClick={() => setPeriod('weekly')}>
          주간 랭킹
        </button>
        <button role="tab" aria-selected={period === 'all'} className={period === 'all' ? 'on' : ''} onClick={() => setPeriod('all')} data-testid="tab-all">
          전체 통계
        </button>
      </div>
      {data?.me && (
        <section className="card me-card" data-testid="my-rank">
          내 순위: <strong>{data.me.rank ? `${data.me.rank}위` : '집계 대기'}</strong> · {data.me.wins}승 / {data.me.matches}경기 · 승률 {pct(data.me.winRate)} · 최고{' '}
          {formatScore(data.me.bestScore)}점
        </section>
      )}
      {data && (
        <p className="muted small">
          {period === 'weekly'
            ? `${data.weekStart} (월) 주간 · 우승 횟수 → 승률 → 평균 점수 순 · ${data.minMatches}경기 이상부터 정식 순위`
            : '서버에서 확정된 전체 경기 누적 · 우승 횟수 → 승률 → 평균 점수 순'}
        </p>
      )}
      {data && data.entries.length === 0 && <p className="muted">아직 기록된 경기가 없습니다.</p>}
      {data && data.entries.length > 0 && (
        <table className="table" data-testid="leaderboard">
          <thead>
            <tr>
              <th>순위</th>
              <th>닉네임</th>
              <th>우승</th>
              <th>경기</th>
              <th>승률</th>
              <th>평균</th>
              <th>최고</th>
            </tr>
          </thead>
          <tbody>
            {data.entries.map((e) => (
              <tr key={e.userId} className={`${e.userId === user.id ? 'me' : ''} ${e.qualified ? '' : 'unqualified'}`}>
                <td>{e.rank ?? '-'}</td>
                <td>{e.nickname}</td>
                <td>{e.wins}</td>
                <td>{e.matches}</td>
                <td>{pct(e.winRate)}</td>
                <td>{formatScore(e.averageScore)}</td>
                <td>{formatScore(e.bestScore)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <ErrorNote error={error} />
    </Screen>
  );
}
